const isSafeExternalUrl = (url) => Boolean(url) && (url.startsWith('https://') || url.startsWith('http://'));

export default isSafeExternalUrl;
